
class MainNavigation {

	constructor() {
		
        this.parentNodes = document.querySelectorAll('.main-menu__item');
        this.parentLinks = document.querySelectorAll('.main-menu__item > a');
        this.childContainer = document.querySelector('.navigation-overlay__child-container');

        this.init();

    }


    setActiveParent( element ) {

        // remove active class from parentItem containers
        this.parentNodes.forEach(c => {
            c.classList.remove('main-menu__item--active')
        })

        // empty child container
        this.childContainer.innerHTML = '';
        if ( element.nextElementSibling ) {

            // Set active class
            element.parentNode.classList.add('main-menu__item--active')

            // clone children and append to child container
            const clonedChildren = element.nextElementSibling.cloneNode(true);
            this.childContainer.append( clonedChildren )

        }

    }
    

    attachEventListeners() {

        this.parentLinks.forEach(item => {
            item.addEventListener('mouseenter', e => {
                this.setActiveParent(e.target)
            })
        })

    }


	init() {
        this.attachEventListeners();
	}

}
export default MainNavigation
